[
	{
		"header": "Order Date time",
		"field": "dateRange",
		"datatype": "String",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Side",
		"field": "buySellCode",
		"datatype": "choice",
		"dropdown": "YES",
		"value": "Enter Value",
		"dropdownvalue": [
			{
				"label": "None",
				"value": ""
			},
			{
				"label": "B-(buy)",
				"value": "B"
			},
			{
				"label": "SL-(sell long)",
				"value": "SL"
			},
			{
				"label": "SS-(short sale)",
				"value": "SS"
			},
			{
				"label": "SX-(short sale exempt)",
				"value": "SX"
			}
		]
	},
	{
		"header": "order Receiving Date",
		"field": "orderReceivingDate",
		"datatype": "String",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "firm Order ID",
		"field": "firmOrderID",
		"datatype": "String",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "order Cancel Timestamp",
		"field": "orderCancelTimestamp",
		"datatype": "DateTime",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "cancel Type",
		"field": "cancelType",
		"datatype": "choice",
		"dropdown": "YES",
		"value": "Enter Value",
		"dropdownvalue": [
			{
				"label": "None",
				"value": ""
			},
			{
				"label": "F-(full)",
				"value": "F"
			},
			{
				"label": "P-(partial)",
				"value": "P"
			}
		]
	},
	{
		"header": "cancel Quantity",
		"field": "cancelQuantity",
		"datatype": "Int",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "cancel Leaves Quantity",
		"field": "cancelLeavesQuantity",
		"datatype": "Int",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "cancelled By OR Modified By",
		"field": "cancelledByORModifiedBy",
		"datatype": "choice",
		"dropdown": "YES",
		"value": "Enter Value",
		"dropdownvalue": [
			{
				"label": "None",
				"value": ""
			},
			{
				"label": "C-(Customer Cancelled,Customer Modified)",
				"value": "C"
			},
			{
				"label": "F-(Firm Cancelled,Firm Modified)",
				"value": "F"
			}
		]
	},
	{
		"header": "Branch Seq No",
		"field": "branchSeqNum",
		"datatype": "String",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Routed Order ID",
		"field": "routedOrderID",
		"datatype": "String",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	},
	{
		"header": "Sent TO Routed Order ID",
		"field": "sentToRoutedOrderID",
		"datatype": "String",
		"dropdown": "NO",
		"value": "Enter Value",
		"dropdownvalue": ""
	}
]